<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<div class="panel panel-default">
					<div class="panel-heading">
						<h5 class="panel-title">
							<a data-toggle="collapse" href="javascript:void(0);" data-parent="#accordion" data-target="#searchoption">My Classes</a>
						</h5>
					</div>
					<div id="searchoption" class="panel-collapse">
						<div class="panel-body">
							<div class="alert alert-warning box-msg" role="alert">
								<strong>Click on Period to populate list of students !</strong>
							</div>

							<div *ngIf="LoadingPeriods == true" class="alert alert-info">
								<strong>Loading. Please wait...</strong>
							</div>

							<table>
								<tbody>
									<tr>
										<td *ngFor="let c of periodList">
											<span style="display: inline-block; width: 8px"></span>
											<span class="dropdown" dropdown [dropdownToggle]="true">
												<!------------------->
												<!--Select a Period-->
												<!------------------->
												<button
													style="margin: 15px"
													[ngStyle]="{
														'background-color': c.buttonColor
													}"
													class="btn-group-vertical"
													(click)="SectionGetList(c.PeriodID)"
													dropdown-open
												>
													{{ c.PeriodDesc }}
													<span class="caret"></span>
												</button>

												<div class="dropdown-menu" *ngIf="multipleSection">
													<div *ngFor="let s of sectionList">
														<table class="table table-striped table-bordered dataTable" role="grid" style="width: 100%">
															<tbody>
																<tr style="background-color: burlywood" (click)="btnClick($event, s.SectionScheduleDetailID)">
																	{{
																		s.CourseDesc
																	}}
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</span>
										</td>
									</tr>
								</tbody>
							</table>

							<div class="row">
								<div class="col-md-5 col-md-offset-0">
									<div *ngIf="courseDetail" class="panel panel-info">
										<div class="panel-heading">Course Details</div>
										<div class="panel-body">
											<div class="form-group">
												<table width="80%">
													<tbody>
														<tr>
															<td>
																<label class="lables">Course Name: </label>
															</td>
															<td>
																{{ filteredSectionList?.CourseDesc }}
															</td>
														</tr>
														<tr>
															<td>
																<label class="lables">Section No: </label>
															</td>
															<td>
																{{ filteredSectionList?.SectionNo }}
															</td>
														</tr>
														<tr>
															<td>
																<label class="lables">Room No: </label>
															</td>
															<td>
																{{ filteredSectionList?.RoomNo }}
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!--
              <div class="column">
                <div class="col-md-4 col-md-offset-6">
                  <div *ngIf="courseDetail" class="panel panel-info">
                    <div class="panel-heading">Attendance Information</div>
                    <div class="panel-body">
                      <div>
                        <table width="50%">
                          <tbody>

                            <tr>
                              <td> <label class="lables">Semester: </label></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td> <label class="lables">Classcuts:</label></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td> <label class="lables">School Year: </label></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td> <label class="lables">Classcuts:</label></td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

</div> -->
						</div>
						<button
							style="margin: 15px; font-size: 10px; background-color: rgb(65, 180, 225); color: rgb(65, 180, 225); border-radius: 50%"
							class="btn-group-vertical"
						>
							G
						</button>
						Current class.
						<button style="margin: 15px; font-size: 10px; background-color: green; color: green; border-radius: 50%" class="btn-group-vertical">
							G
						</button>
						Attendance taken for this class.
						<button style="margin: 15px; font-size: 10px; background-color: yellow; color: yellow; border-radius: 50%" class="btn-group-vertical">
							G
						</button>
						Class in future, Attendance not taken.
						<button style="margin: 15px; font-size: 10px; background-color: red; color: red; border-radius: 50%" class="btn-group-vertical">
							G
						</button>
						You are late, Please take attendance!
						<br />
						<div style="text-align: center">
							<button
								type="button"
								class="btn btn-primary"
								(click)="showPastRecord()"
								href="javascript:void(0);"
								(mouseover)="onhover()"
								(mouseout)="nohover()"
							>
								Past Attendance
							</button>
						</div>
						<div style="text-align: center" *ngIf="pastAttendance">
							<span *ngIf="pastAttendance" style="color: chocolate; text-align: center"
								>Click this button to see past uneditable attendance records !</span
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="pastRecord">
	<div class="row">
		<div class="col-lg-12">
			<div class="ibox float-e-margins">
				<div class="ibox-content">
					<div class="panel panel-default">
						<div class="panel-heading">
							<h5 class="panel-title">
								<a data-toggle="collapse" href="javascript:void(0);" data-parent="#accordion" data-target="#searchoption"
									>View saved attendance</a
								>
							</h5>
						</div>
						<div id="searchoption" class="panel-collapse">
							<div class="panel-body">
								<form class="form-horizontal">
									<div class="form-group">
										<label class="col-sm-4 control-label">Date</label>

										<div class="col-sm-8 col-md-8 col-lg-6">
											<p-calendar
												showIcon="true"
												showButtonBar="true"
												(ngModelChange)="onclassDateChange($event)"
												[(ngModel)]="classDate"
												name="txtDate"
											></p-calendar>
											<h5>Please Select past date to see saved record..!</h5>
										</div>
									</div>

									<div class="form-group">
										<label class="col-sm-4 control-label">Period</label>

										<div class="col-sm-8 col-md-8 col-lg-6">
											<select
												class="form-control"
												name="PeriodID"
												(ngModelChange)="onPeriodChange($event)"
												[(ngModel)]="SelectedPeriodID"
											>
												<option value="" style="display: none"></option>
												<option *ngFor="let c of pastPeriodList" [ngValue]="c.PeriodID">
													{{ c.PeriodDesc }}
												</option>
											</select>
										</div>
									</div>
									<div class="form-group">
										<label class="col-sm-4 control-label">Section</label>

										<div class="col-sm-8 col-md-8 col-lg-6">
											<select class="form-control" name="Section" [(ngModel)]="SectionScheduleDetailID">
												<option value="" style="display: none"></option>
												<option *ngFor="let c of pastSectionList" [ngValue]="c.SectionScheduleDetailID">
													{{ c.CourseDesc }}
												</option>
											</select>
										</div>
									</div>

									<div class="form-group">
										<div class="input-group-btn" class="col-sm-10 control-label">
											<button type="button" class="btn btn-primary" (click)="viewAttendance(1)">View Attendance</button>
											<button type="button" class="btn btn-danger" (click)="viewAttendance(2)">Cancel</button>
											<div *ngIf="PleaseSelect" class="alert alert-danger box-msg" role="alert">
												<strong>Please Select period and section both...</strong>
											</div>
											<!-- <div *ngIf="hideSharedLinkCopyMessage4" class="alert alert-warning box-msg " role="alert">
                      <strong>Loading...</strong>
                    </div> -->
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<caass-classroom-classroomAttendance> </caass-classroom-classroomAttendance>
